import React, { createContext, FC, useContext } from 'react';
import { Subtract } from 'utility-types';
import { ItemProps } from './types';

export const ItemContext = createContext<ItemProps | undefined>(undefined);

export const useItemContext = () => {
  const value = useContext(ItemContext);
  if (!value) {
    throw new Error('Can not find item context. Did you forget to wrap your component with <ItemContext.Provider/>?');
  }
  return value;
};

export const withItemContext = <T extends ItemProps>(Component: FC<T>): FC<Subtract<T, ItemProps>> => (props) => {
  const itemContextValue = useItemContext();
  return <Component {...itemContextValue} {...(props as T)} />;
};
